import React, { useRef, useState } from 'react'

import clsx from 'clsx'

import { Container } from 'components/Grid'
import HoverEvent from 'components/HoverEvent/HoverEvent'
import Icon from 'components/Icon'
import Typography from 'components/Typography'
import { useAppContext } from 'context/AppContext'
import { kFormatter } from 'helpers/formatters'
import setRatingDistributionValues from 'helpers/setRatingDistributionValues'
import { useIsomorphicLayoutEffect } from 'hooks'

import RatingBreakdownLink from './components/RatingBreakdownLink'

import classes from './RatingBreakdownTooltip.module.scss'

/** @type {import('./types').default} */
const RatingBreakdownTooltip = ({ children, ratings, ratingsHrefs = {} }) => {
  const [tooltipPos, setTooltipPos] = useState(0)
  const ref = useRef(null)
  const { route } = useAppContext()

  const ratingValues = setRatingDistributionValues(ratings)

  useIsomorphicLayoutEffect(() => {
    setTooltipPos({ left: ref?.current?.offsetWidth / 2 - 326 / 2, top: ref?.current?.offsetHeight + 5 })
  }, [])

  return (
    <HoverEvent
      className={clsx('RatingBreakdownTooltip', classes.tooltip)}
      role="tooltip"
      event={{
        name: 'engagement_hover',
        engagementDetails: 'hover_product-rating',
        engagementDestination: 'show_rating-breakdown',
        engagementComponent: `product_card-${route}`,
      }}
    >
      <span ref={ref} className={classes.childContainer}>
        {children}
      </span>
      <div className={classes.tooltipContentWrapper} style={{ left: `${tooltipPos.left}px` }}>
        <div className={classes.arrow} />
        <div className={classes.tooltipContent}>
          <div className={classes.linksContainer}>
            {[5, 4, 3, 2, 1].map(key => (
              <RatingBreakdownLink
                key={`review-link-${key}`}
                href={ratingsHrefs[key]}
                disabled={!ratings[key]}
                starRating={key}
                percentage={ratingValues[key]}
                reviews={kFormatter(ratings[key])}
              />
            ))}
          </div>
          <Container className={classes.trustBannerContainer}>
            <div className={classes.disclaimer}>
              <div className={classes.icon}>
                <Icon icon="circle-info" prefix="far" size="16" />
              </div>

              <Typography>
                Based on GetApp&lsquo;s extensive, proprietary database of in-depth, verified user reviews
              </Typography>
            </div>
          </Container>
        </div>
      </div>
    </HoverEvent>
  )
}

export default RatingBreakdownTooltip
